module.exports = __webpack_public_path__ + "img/declare.3ec05d48.jpg";